import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class ConstantAuthorFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  copyrights$ = this.store.select(FlatStates.CopyrightEntityState.entities$);
  copyright$ = this.store.select(FlatStates.ConstantAuthorState.copyright$);
  copyrightArray$ = this.store.select(FlatStates.CopyrightEntityState.copyrightArray$);
  
  modalities$ = this.store.select(FlatStates.ModalityEntityState.entities$);
  modality$ = this.store.select(FlatStates.ConstantAuthorState.modality$);
  modalityArray$ = this.store.select(FlatStates.ModalityEntityState.modalityArray$);
  
  stains$ = this.store.select(FlatStates.StainEntityState.entities$);
  stain$ = this.store.select(FlatStates.ConstantAuthorState.stain$);
  stainArray$ = this.store.select(FlatStates.StainEntityState.stainArray$);

  //</editor-fold>

  //<editor-fold desc="Snapshot Selectors">

  snapshot_copyright = () => this.store.selectSnapshot(FlatStates.ConstantAuthorState.copyright$);
  snapshot_modality = () => this.store.selectSnapshot(FlatStates.ConstantAuthorState.modality$);
  snapshot_stain = () => this.store.selectSnapshot(FlatStates.ConstantAuthorState.stain$);

  //</editor-fold>

  //<editor-fold desc="Requests">

  //<editor-fold desc="Copyrights">
  requestGetCopyrights() {
    return this.store.dispatch(new FlatActions.ConstantAuthorActions.GetCopyrights());
  }

  requestAddCopyright(copyright: FlatModels.CopyrightEntityModels.Copyright) {
    return this.store.dispatch(new FlatActions.CopyrightEntityActions.AddEntity(copyright));
  }

  requestUpdateCopyright(copyright: FlatModels.CopyrightEntityModels.Copyright) {
    return this.store.dispatch(new FlatActions.CopyrightEntityActions.UpdateEntity(copyright));
  }

  requestRemoveCopyright(copyright: FlatModels.CopyrightEntityModels.Copyright) {
    return this.store.dispatch(new FlatActions.CopyrightEntityActions.RemoveEntity(copyright));
  }
  //</editor-fold>

  // <editor-fold desc="Modalities">
  
  requestGetModalities() {
    return this.store.dispatch(new FlatActions.ConstantAuthorActions.GetModalities());
  }

  requestAddModality(modality: FlatModels.ModalityEntityModels.Modality) {
    return this.store.dispatch(new FlatActions.ModalityEntityActions.AddEntity(modality));
  }

  requestUpdateModality(modality: FlatModels.ModalityEntityModels.Modality) {
    return this.store.dispatch(new FlatActions.ModalityEntityActions.UpdateEntity(modality));
  }

  requestRemoveModality(modality: FlatModels.ModalityEntityModels.Modality) {
    return this.store.dispatch(new FlatActions.ModalityEntityActions.RemoveEntity(modality));
  }
  //</editor-fold>

  //<editor-fold desc="Stains">
  
  requestGetStains() {
    return this.store.dispatch(new FlatActions.ConstantAuthorActions.GetStains());
  }

  requestAddStain(stain: FlatModels.StainEntityModels.Stain) {
    return this.store.dispatch(new FlatActions.StainEntityActions.AddEntity(stain));
  }

  requestUpdateStain(stain: FlatModels.StainEntityModels.Stain) {
    return this.store.dispatch(new FlatActions.StainEntityActions.UpdateEntity(stain));
  }

  requestRemoveStain(stain: FlatModels.StainEntityModels.Stain) {
    return this.store.dispatch(new FlatActions.StainEntityActions.RemoveEntity(stain));
  }
  
  //</editor-fold>

  //</editor-fold>

}
